<template>
  <div class="mx-auto info-banner text-left" @click="clicked()">
    <v-alert color="primary" class="white--text" type="info" dark dense>
      <div
        class="banner controlled-font"
        :style="UnderlineText ? 'text-decoration: underline !important;' : ''"
      >
        {{ BannerText }}
      </div>
    </v-alert>
  </div>
</template>

<script>
export default {
  props: {
    BannerText: { required: true },
    UnderlineText: Boolean,
  },
  methods: {
    clicked() {
      this.$emit("OnClick");
    },
  },
};
</script>

<style scoped>
.banner {
  color: white !important;
}
.info-banner {
  /*max-width: 1300px !important;*/
  margin-bottom: 10px;
}
.v-alert--dense {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}
.v-alert {
  margin-bottom: 0px !important;
}
</style>
